/**
 * Typed helpers to build `sections` entries for {@link FilterSlideout}.
 * Keeps config objects consistent and improves autocomplete via JSDoc.
 */

function createSection(type, config) {
  return { type, ...config };
}

/** @param {Omit<import('./FilterSlideout.types.js').FilterSlideoutChipSelectSection, 'type'>} config */
export function createChipSelectSection(config) {
  return createSection('chip-select', config);
}

/** @param {Omit<import('./FilterSlideout.types.js').FilterSlideoutToggleListSection, 'type'>} config */
export function createToggleListSection(config) {
  return createSection('toggle-list', config);
}

/** @param {Omit<import('./FilterSlideout.types.js').FilterSlideoutMultiSelectSection, 'type'> & { type?: 'multi-select' }} config */
export function createMultiSelectSection(config) {
  return createSection('multi-select', config);
}

/** @param {Omit<import('./FilterSlideout.types.js').FilterSlideoutMultiSelectSection, 'type'> & { type?: 'priority' }} config */
export function createPrioritySection(config) {
  return createSection('priority', config);
}

/** @param {Omit<import('./FilterSlideout.types.js').FilterSlideoutSingleSelectSection, 'type'> & { type?: 'date-presets' }} config */
export function createDatePresetsSection(config) {
  return createSection('date-presets', config);
}

/** @param {Omit<import('./FilterSlideout.types.js').FilterSlideoutNumericRangeSection, 'type'>} config */
export function createNumericRangeSection(config) {
  return createSection('numeric-range', config);
}

/** @param {Omit<import('./FilterSlideout.types.js').FilterSlideoutSearchSelectSection, 'type'>} config */
export function createSearchSelectSection(config) {
  return createSection('search-select', config);
}

/** @param {Omit<import('./FilterSlideout.types.js').FilterSlideoutSingleSelectSection, 'type'> & { type?: 'single-select' }} config */
export function createSingleSelectSection(config) {
  return createSection('single-select', config);
}

/** @param {Omit<import('./FilterSlideout.types.js').FilterSlideoutTitleSection, 'type'>} config */
export function createTitleSection(config) {
  return createSection('title', config);
}

/** @param {Omit<import('./FilterSlideout.types.js').FilterSlideoutSingleSelectSection, 'type'> & { type?: 'sort' }} config */
export function createSortSection(config) {
  return createSection('sort', config);
}

/** @param {Omit<import('./FilterSlideout.types.js').FilterSlideoutAssignmentSection, 'type'>} config */
export function createAssignmentSection(config) {
  return createSection('assignment', config);
}

/** @param {Omit<import('./FilterSlideout.types.js').FilterSlideoutDateRangeSection, 'type'>} config */
export function createDateRangeSection(config) {
  return createSection('date-range', config);
}

/** @param {Omit<import('./FilterSlideout.types.js').FilterSlideoutAiInsightsSection, 'type'>} config */
export function createAiInsightsSection(config) {
  return createSection('ai-insights', config);
}
